import React, { Fragment, useContext, useEffect} from 'react';
import { Helmet } from "react-helmet";
import donornotfoundImage from '../Assets/images/donor-x-404.svg';
import { GlobalInfo } from '../Contexts/GlobalContext';
import { useNavigate } from 'react-router-dom';
import TokenService from '../Services/Token.service';

function NotFoundPage(){
    const { setIsRestrictedPage } = useContext(GlobalInfo);
    const navigate = useNavigate();

    useEffect(() => {
    setIsRestrictedPage(true);

    return () => {
        setIsRestrictedPage(false); // cleanup when leaving page
    };
    }, []);

    const goHome = () => {
        const user = TokenService.getUser();
        setIsRestrictedPage(false);

        if (!user) return navigate("/login");

        if (user.roles.includes("Admin") || user.roles.includes("Superadmin"))
        navigate("/admin/sample-requests");
        else if (user.roles.includes("Donor"))
        navigate("/donor/job-board");
        else if (user.roles.includes("Requestor"))
        navigate("/requestor/requestor-sample-requests");
    };

return(
    <>
        <Helmet>
            <title>DonorX | 404 Not Found</title>
        </Helmet>
        <div className=''>
            {/* el-middle  */}
            <div className="el-middle-wrapper ">
                <div className='mt-5 text-center el-login-sec'>
                    <img src={donornotfoundImage} alt="Not Found Picture" />
                    <h1 className="el-title el-404-title"><span>404</span> Not Found.</h1>   
                    <h5 className='mt-5 mb-2'>We couldn’t find the page you’re looking for. Maybe it’s hiding, moved, or just doesn’t exist anymore.</h5> 
                    <h5>Or, you might not have permission to view this content.</h5> 
                         <div className="el-form-btn-submit not-found-go-home w-20">
                            <button onClick={goHome}  className="el-btn-primary" type="button">
                            Go to Homepage
                            </button>
                        </div>
                </div>                
            </div>   
        </div>
    </>
);

}
export default NotFoundPage;